import { handleizeString } from 'utils/string';
import { getLocalDate } from 'utils/date';
import { image as renderImage } from 'utils/image';

/* eslint-disable */
function getTags(tags) {
  return typeof tags === 'string' ? tags.split(',') : tags;
}

/**
 * Render campaign labels
 * @param {*} tags
 * @returns
 */

function renderLabel(tags) {
  const { labels } = window.theme.strings.product;

  // Bail early
  if (tags === '' || tags === undefined) return '';

  let html = '';
  const tagList = getTags(tags);

  const types = [
    {
      name: 'bf-',
      label: labels.blackFriday,
    },
    {
      name: 'js-',
      label: labels.januarySale,
    },
    {
      name: 'ss-',
      label: labels.summerSale,
    },
    {
      name: 'ms-',
      label: labels.midseasonSale,
    },
  ];

  for (const type of types) {
    const { name, label } = type;
    const tag = tagList.filter((tag) => tag.substr(0, 3).toLowerCase() === name);

    if (tag.length) {
      const parts = tag[0].split('-');
      const percentage = parts[parts.length - 1];
      html += `
        <span class="product-item__labels-item ${name.replace('-', '')}">
          <span class="name">${label}</span>
          <span class="highlight">${percentage}%</span>
        </span>`;
    }
  }

  return html;
}

/**
 * Render all product labels
 * @param {*} item
 * @returns
 */

function renderLabels(item, isExclusive = false, isWaterproof = false) {
  const { tags, variants: [variant] } = item;
  const { price, compare_at_price } = variant;

  const { labels } = window.theme.strings.product;

  let html = '<div class="product-item__labels">';

  if (isWaterproof) {
    html += `
    <div class="product-item__labels-item is-waterproof">
      ${window.theme.icons.waterproofLabel}
    </div>`;

  } else if (isExclusive) {
    html += `
    <div class="product-item__labels-item is-exclusive">
      ${window.theme.icons.exclusiveLabel}
    </div>`;

    html += `<p class="product-item__labels-text">${window.theme.strings.product.labels.exclusiveDescription}</p>`;
  }

  const campaignLabelsHTML = renderLabel(tags);
  html += campaignLabelsHTML;

  if (Number(compare_at_price) > Number(price) && campaignLabelsHTML === '') {
    html += `<span class="product-item__labels-item on-sale">${labels.sale}</span>`;
  }

  html += `<span class="product-item__labels-item sold-out">${labels.soldOut}</span>`;

  html += '</div>';

  return html;
}

/**
 * Render prices
 * @param {*} price
 * @param {*} compare_at_price
 * @returns
 */

function renderPrice(price, compare_at_price) {
  let html = '';
  const onSale = compare_at_price > price ? 'on-sale' : '';

  html += `<span class="product-item__price ${onSale}">${Shopify.formatMoney(price * 100, theme.moneyFormat)}</span>`;

  if (compare_at_price > price) {
    html += `<del class="product-item__price product-item__price-old">${Shopify.formatMoney(compare_at_price * 100, theme.moneyFormat)}</del>`;
  }

  return html;
}

/**
 * Render quickbuy variants
 * @param {*} values
 * @param {*} variants
 * @returns
 */

function renderValues(parentID, variants, isShoe) {
  const data = [];

  variants.forEach((variant) => {
    const id = `${variant.title} - ${variant.id} - ${parentID}`;
    const options = variant.title.split(' / ');
    let title = options[options.length - 1];

    // Handle title
    if (isShoe) {
      title = title.substring(1);
    } else {
      const parts = title.split('_');
      title = parts[parts.length - 1];
    }

    data.push({
      id,
      title,
      variant: {
        id: variant.id,
        available: variant.available,
      },
    });
  });

  return data;
}

function renderRelated(item) {
  const {
    relatedOpposite, id, gender, isShoe,
  } = item;

  if (relatedOpposite === null || relatedOpposite === undefined) return '';

  const related = relatedOpposite[0];
  const { handle, variants } = related;

  let label = window.theme.strings.product.gender.women;
  let title = 'Women';

  if (gender === 'Women') {
    title = 'Men';
    label = window.theme.strings.product.gender.men;
  }

  return String.raw`
    <div class="related-gender font-medium">
      <span class="related-gender__item inline-block mr-2 is-active" data-switch="${handleizeString(gender)}">${window.theme.strings.product.gender[handleizeString(gender)]}</span>
      <a class="related-gender__item" href="${`/products/${handle}`}" data-switch="${handleizeString(title)}">${label}</a>
    </div>

    <div class="product-item__form-variants hidden"
      data-gender="${handleizeString(title)}"
      data-variants='${JSON.stringify(renderValues(id, variants, isShoe))}'>
    </div>
  `;
}

/**
 * Render product quick buy form
 * @param {*} item
 * @returns
 */

function renderForm(item) {
  const {
    id,
    variants,
    gender,
    isShoe,
  } = item;

  return String.raw`
    <form id="form-${id}" class="product-item__form" method="post" action="/cart/add" enctype="multipart/form-data" data-item-form>
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="quantity" value="1">

      <div class="product-item__form-variants-wrapper">
        <span class="product-item__form-variants-label">
          <span class="mr-5 mt-0.5 mb-0.5">${window.theme.strings.product.labels.euSize}</span>
          ${renderRelated(item)}
        </span>

        <div class="product-item__form-variants"
          data-gender="${handleizeString(gender)}"
          data-variants='${JSON.stringify(renderValues(id, variants, isShoe))}'>
        </div>
      </div>
    </form>
  `;
}

function renderTitleMeta(titleParts) {
  const [, type, gender] = titleParts;

  const typeString = () => (type ? `${type}` : '');
  const genderString = () => (gender ? `, ${gender}` : '');

  return `<div class="product-item__title-meta">${typeString()}${genderString()}</div>`;
}

function isBlockedItem(tags) {
  const upcoming = tags.find((tag) => tag.includes('upcoming!'));

  if (!upcoming) return false;

  const dateString = upcoming.split('!')[1];
  const endDate = getLocalDate(dateString);

  if (new Date().getTime() < endDate.getTime()) {
    return true;
  }

  return false;
}

function renderWishlist({ id }) {
  return `
    <!-- include 'wishlist-button' with '${id}' -->
  `;
}

export default function productCard(item, collectionHandle, app, imageCrop = true, displayForm = true, isClerk = false, wrapperClass = 'collection__product') {
  const {
    title,
    id,
    image,
    image_alt,
    handle,
    tags,
  } = item;

  let soldOutClass = false;

  if (app) {
    const { query } = app.getState().filter;

    const variantOptionsFilter = query.filter((q) => q.type === 'variants.title');
    let variantSoldOut = false;

    if (variantOptionsFilter && variantOptionsFilter[0].params.length) {
      const filter = variantOptionsFilter[0];
      const [key] = filter.type.split('.');
      const { params } = filter;

      const variantMatch = params.map((param) => item[key].find((variant) => variant.options.map((option) => option.value).filter((values) => values === param).length));
      if (variantMatch.length && !variantMatch.some((variant) => variant?.available ?? false)) variantSoldOut = true;
    }

    soldOutClass = variantSoldOut ? 'variant-sold-out' : '';
  }

  const url = collectionHandle !== '' ? `/collections/${collectionHandle}/products/${handle}` : `/products/${handle}`;

  const titleParts = title.split(' | ');
  const [name] = titleParts;

  const tagList = getTags(tags);

  const isExclusive = tagList.includes('exclusive');
  const isWaterproof = tagList.includes('waterproof')

  const isBlocked = isBlockedItem(tagList);
  if (isBlocked) displayForm = false;

  let clerkAttribute = '';
  if (isClerk) clerkAttribute = `data-clerk-product-id="${id}"`;

  return String.raw`
    <article id="product-${id}" class="product-item ${wrapperClass} ${soldOutClass}" data-component="ProductItem" ${clerkAttribute}>
      <div class="product-item__inner-wrapper ${(isExclusive ? 'group' : '')}">

        <div class="product-item__inner">
          ${(isExclusive ? window.theme.icons.exclusive : '')}
          ${renderLabels(item, isExclusive, isWaterproof)}

          <div class="product-item__image-wrapper">
            ${renderImage(image, 'product-item__image', imageCrop)}
            ${renderImage(image_alt, 'product-item__image--alt', imageCrop)}
          </div>

          ${(() => (displayForm ? renderForm(item) : ''))()}

          <div class="product-item__actions">
            ${renderWishlist(item)}

            ${(() => (displayForm ? `
              <button type="button" class="font-medium items-center text-xs" data-trigger-form="${id}">
                <div class="product-item__quickbuy-default">
                  <div class="product-item__quickbuy-trigger">
                    <span class="mr-1 w-3 h-3">${window.theme.icons.cart}</span>
                    <span>${window.theme.strings.product.quickbuy}</span>
                  </div>
                  <span class="product-item__quickbuy-trigger-active">${window.theme.strings.product.quickbuyClose}</span>
                </div>

                <div class="product-item__quickbuy-added">
                  <span class="mr-1 w-3 h-3">${window.theme.icons.checkmark}</span>
                  <span>${window.theme.strings.addedToCart}</span>
                </div>
              </button>
              ` : ''))()}
          </div>
        </div>

        <div class="product-item__content-wrapper">
          <div class="flex-1">
            <header class="product-item__header">
              <div class="product-item__header-inner">
                ${renderTitleMeta(titleParts)}
                <h5 class="product-item__title">${name}</h5>
              </div>
            </header>

            <div class="product-item__prices">
              ${renderPrice(Number(item.variants[0].price), Number(item.variants[0].compare_at_price))}
            </div>
          </div>
        </div>

        <a class="product-item__link" href="${url}">
          <span class="sr-only">${name}</span>
        </a>
      </div>
    </article>
  `;
}
